const sizeClasses = {
  h1: 'text-xlMobile md:text-2xl',
  h2: 'text-lgMobile md:text-xl',
  h3: 'text-md',
  h4: 'text-[2rem]',
};

const Heading: React.FC<Blog.HeadingProps> = ({
  color = 'text-navy',
  html = false,
  id = null,
  level,
  style = '',
  text,
}): JSX.Element => {
  const Tag = level;
  const styles = `${color} ${sizeClasses[level]} ${style}`;
  return (
    <>
      {html ? (
        <Tag
          className={`${styles}`}
          dangerouslySetInnerHTML={{ __html: text }}
          id={id}
        />
      ) : (
        <Tag className={`${styles}`} id={id}>
          {text}
        </Tag>
      )}
    </>
  );
};

export default Heading;
